export default __webpack_public_path__ + "static/media/home.16d9e59c.svg";